import type { QueryClient } from "@tanstack/react-query";
import { createRoute, useLoaderData } from "@tanstack/react-router";
import { previewContentPageQueryOptions, type PreviewContentSearch } from "~/app/api/pageData/previewContentPageQuery";
import { unwrapPageInitialData } from "~/app/api/pageData/pageInitialDataLoader";
import type { PageInitialData } from "~/app/api/pageData/pageInitialDataTypes";
import { rootRoute } from "~/app/router/rootRoute";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";

const PREVIEW_CONTENT_PATH = "/preview-content";

function PreviewContentRoute() {
  const result = useLoaderData({
    from: PREVIEW_CONTENT_PATH,
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {null}
    </StorefrontShellFrame>
  );
}

export async function loadPreviewContentPageData(context: { queryClient: QueryClient }, search: PreviewContentSearch) {
  const result = await context.queryClient.ensureQueryData(previewContentPageQueryOptions(search));
  return unwrapPageInitialData(result);
}

export const previewContentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: PREVIEW_CONTENT_PATH,
  validateSearch: (search: Record<string, unknown>): PreviewContentSearch => ({
    uid: typeof search.uid === "string" ? search.uid : undefined,
    cmsTicketId: typeof search.cmsTicketId === "string" ? search.cmsTicketId : undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => loadPreviewContentPageData(context, deps),
  component: PreviewContentRoute,
});
